var map = {
	"./add01.png": 25643,
	"./add02.png": 19702,
	"./add03.png": 93737,
	"./chess-icon.png": 95469,
	"./chess.png": 64280,
	"./egame-icon.png": 20609,
	"./egame.png": 83374,
	"./fishing-icon.png": 10845,
	"./fishing.png": 12743,
	"./footer01.png": 37878,
	"./footer02.png": 54409,
	"./footer03.png": 80519,
	"./footer04.png": 30492,
	"./footer05.png": 11814,
	"./footer06.png": 29798,
	"./footer07.png": 17519,
	"./footer08.png": 74398,
	"./gaming-icon.png": 27741,
	"./gaming.png": 92352,
	"./lottery-icon.png": 6749,
	"./lottery.png": 66897,
	"./realbet-icon.png": 33757,
	"./realbet.png": 47723,
	"./sport-icon.png": 35103,
	"./sport.png": 89314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46766;